<template>
  <base-outlined-button
    :text="text"
    color="primary"
    :icon="icon"
    :disabled="isDisabled"
    :loading="loading"
    :toolbar="toolbar"
    :small="small"
    @onButtonClick="onButtonClick"
  />
</template>

<script>
  import ButtonMixin from '../mixins/Button';

  export default {
    name: "AddButton",
    mixins: [ButtonMixin],
    props: {
      icon: {
        type: String,
        default: "mdi-plus"
      }
    }
  }
</script>
